import graphql from 'babel-plugin-relay/macro';
import { useLazyLoadQuery } from 'react-relay';
import { GetJobQuery } from './__generated__/GetJobQuery.graphql';

const getJobQuery = graphql`
  query GetJobQuery($id: ID!) {
    getJob(id: $id) {
      id
      key
      customerId
      customer {
        id
        key
        name
        categoryId
      }
      description
      notes
      jobCategoryId
      jobCategory {
        id
        name
        description
        reportType
        parentId
        methodsOfUse {
          description
        }
        procedures {
          description
        }
        easeOfUseRatings {
          description
        }
        ageGroups {
          groupNumber
          beginAge
          endAge
          groupPercentage
        }
      }
      preparedById
      preparedBy {
        id
        email
        username
        role
        isActive
      }
      status
      regions {
        id
        name
        enabled
      }
      participants {
        id
        jobId
        createdById
        siteId
        sampleId
        custSampleNum
        sex
        groupNum
        testDateTime
        birthDate
        age
        zip
        participantData
        proctorId
      }
      samplePicture
      sampleType
      submitter
      testType
      participantType
      requiredParticipants
      numberOfParticipants
      maxParticipantsPerSite
      maxParticipantsPerProctor
      customerTest
      reportTree
      testObjectId
      requiredTorque
      disclaimer
      otherInfo
      reportHistory
      testDescription
      objectives
      procedureNotes
      resultsDiscussion
      endDate
      methodsOfUse {
        description
      }
      procedures {
        description
      }
      easeOfUseRatings {
        description
      }
      ageGroups {
        groupNumber
        beginAge
        endAge
        groupPercentage
      }
      updatedAt
      updatedBy {
        email
        role
        isActive
        username
      }
      parent {
        id
        key
      }
      children {
        id
        key
      }
    }
  }
`;

const useGetJobQuery = (id: string) => {
  return useLazyLoadQuery<GetJobQuery>(
    getJobQuery,
    { id },
    { fetchPolicy: 'store-and-network' }
  ).getJob;
};

export { useGetJobQuery };
